import type { GovernancePolicyFormData } from '@experiences/interfaces';
import React from 'react';

import { GovernancePolicyCreateSelectFlow } from './GovernancePolicyCreateSelectFlow';
import { GovernancePolicyCreateWizard } from './GovernancePolicyCreateWizard';

interface GovernanceCreateContentProps {
    showStartComponent: boolean;
    setShowStartComponent: (show: boolean) => void;
    onSubmitHandler: (data: GovernancePolicyFormData) => Promise<void>;
    initialStep?: number;
    mode?: 'create' | 'edit';
    returnUrl?: string;
}

export const GovernanceCreateContent: React.FC<GovernanceCreateContentProps> = ({
    showStartComponent,
    setShowStartComponent,
    onSubmitHandler,
    initialStep,
    mode = 'create',
    returnUrl,
}) => {
    if (showStartComponent) {
        return (
            <GovernancePolicyCreateSelectFlow
                onStartStepper={() => setShowStartComponent(false)}
                returnUrl={returnUrl}
            />
        );
    }

    return (
        <GovernancePolicyCreateWizard
            onSubmitHandler={onSubmitHandler}
            initialStep={initialStep}
            mode={mode}
            returnUrl={returnUrl}
        />
    );
};
